import { ReactElement } from 'react';
import { useModel, ItemLoader, UpdateContainer, useEntity, withHasPerm } from 'components';
import { Company } from 'types';
import { SelectField } from '@ff-it/form';
import { Option } from 'options';
import { any, useHasPerms } from 'core/permissions';
import { invoicingPreferencesPermissions } from './permissions';

interface InvoicingPreferences {
  default_finance_period: '' | 'CURRENT_MONTH' | 'CURRENT_OR_PREVIOUS' | null;
}

const financePeriodOptions: Option<string>[] = [
  { value: 'CURRENT_MONTH', label: 'Current month' },
  {
    value: 'CURRENT_OR_PREVIOUS',
    label: 'Previous month if day ≤ 20, otherwise current month',
  },
];

export const Invoicing = withHasPerm(
  function Invoicing(): ReactElement {
    const endpoint = useModel().endpoint;
    const entityId = useEntity<Company>().item.id;
    const [hasChange] = useHasPerms(invoicingPreferencesPermissions.change);
    const url = `${endpoint}${entityId}/invoicing_preferences/`;

    return (
      <ItemLoader<InvoicingPreferences> url={url}>
        {({ setItem, item }) => (
          <UpdateContainer
            url={url}
            initialValues={item}
            updateItem={setItem}
            method="PUT"
            successMessage="Invoicing preferences saved successfully"
            disabled={!hasChange}
          >
            <div className="container px-0 ml-0">
              <div className="row">
                <div className="col-6">
                  <SelectField
                    name="default_finance_period"
                    label="Default Finance Period"
                    options={financePeriodOptions}
                    simple
                  />
                </div>
              </div>
            </div>
          </UpdateContainer>
        )}
      </ItemLoader>
    );
  },
  any(invoicingPreferencesPermissions.view, invoicingPreferencesPermissions.change),
);
